/**
 * School sidebar menu configuration — extracted from SchoolDetailPage.jsx to keep the shell lean.
 * Keep this in sync with the renderTab() switch in SchoolDetailPage.jsx.
 */
import {
  LayoutDashboard, BarChart3, FileText, Trophy, Clock, ClipboardCheck, Users, Users2,
  UserCog, Briefcase, UserCheck, HeartHandshake, School, BookOpenCheck, Calendar,
  CalendarRange, GraduationCap, Award, ArrowUpCircle, ClipboardList, Bus, CreditCard,
  Banknote, Bell, Zap, MessagesSquare, MessageSquare, Mail, Globe, ShieldCheck, Eye, Settings,
  Shield, ShieldAlert, LifeBuoy, Building2, UtensilsCrossed, ShoppingCart, ArrowLeftRight
} from 'lucide-react';
import { BookOpen as LibraryIcon } from 'lucide-react';

export const SCHOOL_MENU_GROUPS = [
  {
    id: 'overview', label: 'Overview',
    items: [
      { id: 'dashboard', label: 'Dashboard', icon: LayoutDashboard },
      { id: 'analytics', label: 'Analytics', icon: BarChart3 },
      { id: 'reports-f', label: 'Reports (F)', icon: FileText },
      { id: 'gamification-g', label: 'Gamification', icon: Trophy },
      { id: 'scheduler', label: 'Scheduler', icon: Clock },
    ],
  },
  {
    id: 'people', label: 'People',
    items: [
      { id: 'admissions', label: 'Admissions', icon: ClipboardCheck },
      { id: 'admissions-pipeline', label: 'Admissions Pipeline', icon: ClipboardCheck },
      { id: 'students', label: 'Students', icon: Users },
      { id: 'transfers', label: 'Transfers', icon: ArrowLeftRight },
      { id: 'guardians', label: 'Guardians', icon: Users2 },
      { id: 'teachers', label: 'Teachers', icon: UserCog },
      { id: 'hr', label: 'HR & Staff', icon: Briefcase },
      { id: 'alumni', label: 'Alumni', icon: UserCheck },
      { id: 'alumni-hub', label: 'Alumni Hub', icon: HeartHandshake },
    ],
  },
  {
    id: 'academics', label: 'Academics',
    items: [
      { id: 'faculties', label: 'Faculties', icon: Building2, tertiaryOnly: true },
      { id: 'academic', label: 'Academic', icon: GraduationCap, tertiaryOnly: true },
      { id: 'classes', label: 'Classes', icon: School },
      { id: 'subjects', label: 'Subjects', icon: BookOpenCheck },
      { id: 'academic-years', label: 'Academic Years', icon: Calendar },
      { id: 'semester-report', label: 'Semester Reports', icon: FileText },
      { id: 'timetable', label: 'Timetable', icon: CalendarRange },
      { id: 'attendance', label: 'Attendance', icon: Clock },
      { id: 'exams', label: 'Exams & Grading', icon: Trophy },
      { id: 'report-cards', label: 'Report Cards', icon: FileText },
      { id: 'lms', label: 'LMS', icon: GraduationCap },
      { id: 'certificates', label: 'Certificates', icon: Award },
      { id: 'promotions', label: 'Promotions', icon: ArrowUpCircle },
      { id: 'graduation', label: 'Graduation', icon: GraduationCap },
    ],
  },
  {
    id: 'operations', label: 'Operations',
    items: [
      { id: 'front_office', label: 'Front Office', icon: ClipboardList },
      { id: 'library', label: 'Library', icon: LibraryIcon },
      { id: 'transport', label: 'Transport', icon: Bus },
      { id: 'housing', label: 'Housing', icon: Building2 },
      { id: 'dining', label: 'Dining', icon: UtensilsCrossed },
      { id: 'pos', label: 'Campus Store', icon: ShoppingCart },
      { id: 'access', label: 'ID & Access', icon: CreditCard },
      { id: 'fees', label: 'Fees', icon: Banknote },
    ],
  },
  {
    id: 'communication', label: 'Communication',
    items: [
      { id: 'announcements', label: 'Announcements', icon: Bell },
      { id: 'comm-engine', label: 'Comm Engine', icon: Zap },
      { id: 'pt-messages', label: 'PT Messages', icon: MessagesSquare },
      { id: 'notifications', label: 'SMS / WhatsApp', icon: MessageSquare },
      { id: 'email-settings', label: 'Email Settings', icon: Mail },
      { id: 'website', label: 'CMS / Website', icon: Globe },
    ],
  },
  {
    id: 'administration', label: 'Administration',
    items: [
      { id: 'campuses', label: 'Campuses', icon: Building2 },
      { id: 'team', label: 'Team & Roles', icon: ShieldCheck },
      { id: 'view-as', label: 'View As', icon: Eye },
      { id: 'support-inbox', label: 'Platform Support', icon: LifeBuoy },
      { id: 'settings', label: 'Settings', icon: Settings },
    ],
  },
  {
    id: 'pastoral', label: 'Pastoral & Safeguarding',
    items: [
      { id: 'behaviour', label: 'Behaviour & Discipline', icon: Shield },
      { id: 'safeguarding', label: 'Safeguarding & Complaints', icon: ShieldAlert },
    ],
  },
  {
    id: 'spiritual', label: 'Spiritual',
    items: [
      { id: 'bible-plans', label: 'Bible Reading Plans', icon: BookOpenCheck },
    ],
  },
  {
    id: 'security', label: 'Security & Operations',
    items: [
      { id: 'gate-pass',  label: 'Gate Pass',          icon: ShieldCheck },
      { id: 'incidents',  label: 'Behaviour Reports',  icon: ShieldAlert },
    ],
  },
];

// Flat list for lookups
export const SCHOOL_MENU = SCHOOL_MENU_GROUPS.flatMap(g => g.items);
